import { Flex, Button } from '@chakra-ui/react'
import DateHeader from './DatePicker'
import { exportToImage } from './utils'
import { useExportModal } from 'contexts/ExportModal'
import { Panel } from 'components/Panel'

const Header = ({
  dataLength,
  setStepsEnabled,
  setStepIndex,
}: {
  dataLength: number
  setStepsEnabled: (value: boolean) => void
  setStepIndex: (value: number) => void
}) => {
  const { openModal } = useExportModal()
  return (
    <Panel
      border='1px solid'
      borderColor='gray3'
      background='white'
      borderRadius='8px'
      flex={1}
      display={'flex'}
      py={1}
      px={2}
      mb={2}
      alignItems={'center'}
    >
      <Flex>
        <DateHeader />
      </Flex>
      <Flex gap={2} className='exportButton'>
        <Button
          size={'xs'}
          border={'1px'}
          borderColor={'gray.200'}
          borderRadius={'sm'}
          h={8}
          zIndex={100}
          variant={'solid'}
          onClick={() => {
            localStorage.removeItem('trialsDashboardTourCompleted')
            setStepsEnabled(true)
            setStepIndex(0)
          }}
        >
          View Demo
        </Button>
        <Button
          size={'xs'}
          border={'1px'}
          borderColor={'gray.200'}
          borderRadius={'sm'}
          h={8}
          variant={'solid'}
          onClick={exportToImage}
        >
          Export Image
        </Button>
        <Button
          size={'xs'}
          border={'1px'}
          borderColor={'gray.200'}
          h={8}
          variant={'solid'}
          borderRadius={'sm'}
          onClick={() => openModal('Trials')}
        >
          Export Data
        </Button>
      </Flex>
    </Panel>
  )
}

export default Header
